<template>
  <div class="not-found">
    <div class="card not-card">
      <div class="icon">🔍</div>
      <h1>Pagina nao encontrada</h1>
      <p>Confira o link do evento ou entre em contato com a coordenacao.</p>
      <a href="https://naelshaday.com.br" class="btn-secondary back">Voltar ao site</a>
    </div>
  </div>
</template>

<script>
export default { name: 'NotFoundPage' }
</script>

<style scoped>
.not-found {
  min-height: calc(100vh - 60px);
  display: flex; align-items: center; justify-content: center;
  padding: var(--spacing-base);
}
.not-card {
  padding: var(--spacing-xl);
  max-width: 480px; width: 100%;
  text-align: center;
  display: flex; flex-direction: column; align-items: center; gap: var(--spacing-base);
}
.icon { font-size: 56px; }
h1 { font-size: var(--text-xl); }
p { color: var(--color-text-muted); }
.back { margin-top: var(--spacing-md); text-decoration: none; }
</style>
